import { memo, useCallback } from 'react';
import { Element } from 'src/components';
import { CONTENT_MAP } from '..';
import ContentText, { ITextProps } from '.';
import styles from '../style.module.scss';

export interface IBodyBlockProps extends ITextProps {
    childs: ITextProps[];
}

const BodyBlock = (props: IBodyBlockProps) => {
    const { childs = [], ...blockProps } = props;

    const renderChild = (props: any, i: number) => {
        const Comp = CONTENT_MAP[props.type];
        if (!Comp) {
            return null;
        }

        return <Comp {...props} key={`block_live_item_${i}`} />;
    };

    const renderChildren = useCallback(() => {
        return childs.map((props, i) => renderChild(props, i));
    }, [props]);

    const renderBody = useCallback(() => {
        if (childs.length) {
            return renderChildren();
        }
        return <ContentText {...blockProps} />;
    }, [props]);

    return (
        <Element className={styles['live-body-block']}>{renderBody()}</Element>
    );
};

export default memo(BodyBlock);
